<template>
  <div class="rescue global-rescue">
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">专业的救援客服中心</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle">专业的救援客服中心</h3>
      <h4 class="rescue-title">北京威马捷的救援服务特色 </h4>
      <p class="experience-para">随着电话中心系统及案件管理系统的升级，全球7个呼叫中心的统一工作平台更加稳定、安全。通过这一平台，无论客人身处何方，无论是来电咨询还是重症转运案件，客服人员都可以实现无差别的高效服务。
      </p>
      <div class="experience-part"
           style="margin-bottom:100px;">
        <div class="customer-special">
          <div class="left">
            <p>高品质的专业服务</p>
            <p>广范围的应对能力</p>
            <p>全方位的救援体制</p>
          </div>
          <div class="mid">=</div>
          <div class="right">
            <p>高效·稳定</p>
            <p>安心·安全</p>
          </div>
        </div>
        <div class="structure">
          <div class="top">
            <div class="left">高呼入率&高稳定率</div>
            <div class="mid">
              <span class="vertical"></span>
              <span class="transverse"></span>
            </div>
            <div class="right">经验丰富的专业医疗救援</div>
          </div>
          <div class="middle">
            <div class="item">
              <span class="top"></span>
              <span class="bot"></span>
            </div>
            <div class="item">
              <span class="top"></span>
              <span class="bot"></span>
            </div>
          </div>
          <div class="bottom">
            <div class="item">全球7个呼叫中心通过AVAYA/VIP-VPN电话系统统合为一个平台</div>
            <div class="item">应用自主开发的案件管理系统及合作网络信息管理系统。</div>
            <div class="item">转运经验丰富的医疗顾问团队。</div>
            <div class="item">救援操作经验丰富的客服团队。</div>
          </div>
        </div>
        <!-- <img style="width:100%;margin-bottom: 18px;"
        :src="customer10" alt=""> -->
      </div>
      <h4 class="rescue-title">服务品质保证：客服中心的教育体制 </h4>
      <div class="experience-part">
        <p class="experience-para"
           style="margin-bottom:30px!important;"> 客服中心的人才培养与服务品质管理，是专业救援的基础，也是信赖与品质保障的起点。威马捷的客服培训目标是能够正确、有效地引 导客户就医并为其解决问题的专业救援协调员。
        </p>
        <div class="rescue-flex">
          <div class="rescue-box-item">
            <img class="rescue-img"
                 :src="customer05"
                 alt="">
            <p class="more-case">聘用标准</p>
            <ul class="customer-list">
              <li>
                <span class="icon">•</span>
                <span class="text">判断能力，说明能力，决断能力，行动能力，应变能力，共感能力</span>
              </li>
              <li>
                <span class="icon">•</span>
                <span class="text">使命感，责任感</span>
              </li>
              <li>
                <span class="icon">•</span>
                <span class="text">语言能力（外语商务对话能力）</span>
              </li>
              <li>
                <span class="icon">•</span>
                <span class="text">有旅游业、航空业、服务业、医疗业界经验的人员</span>
              </li>
            </ul>
          </div>
          <div class="rescue-box-item">
            <img class="rescue-img"
                 :src="customer06"
                 alt="">
            <p class="more-case">教育体制 </p>
            <ul class="customer-list">
              <li>
                <span class="icon">•</span>
                <span class="text">以各中心共通的服务标准进行持续性的培训</span>
              </li>
              <li>
                <span class="icon">•</span>
                <span class="text">入职研修，保险商品理解，理赔条款研读，案件管理培训</span>
              </li>
              <li>
                <span class="icon">•</span>
                <span class="text">通过电话练习，听取对话录音，提高与人沟通能力</span>
              </li>
              <li>
                <span class="icon">•</span>
                <span class="text">在前辈监听及指导下实操</span>
              </li>
              <li>
                <span class="icon">•</span>
                <span class="text">对能否入职给予综合评价</span>
              </li>
              <li>
                <span class="icon">•</span>
                <span class="text">定期进行客户满意度测评、业务经验交流会，及专项业务培训</span>
              </li>
            </ul>
          </div>
        </div>

        <p class="more-case">品质管理</p>
        <img class="rescue-img"
             style="width:928px;height:415px;margin:39px auto 99px auto;"
             :src="customer11"
             alt="">
      </div>
      <h4 class="rescue-title">根据需求介绍专科医院 诊前服务 </h4>
      <div class="experience-part">
        <p class="experience-para"
           style="margin-bottom:0px!important;">EAJ通过优秀的救援客服人员，自有的合作网络信息库，以及专业救援服务系统，根据患者的症状及程度，为患者筛选出最合适的医疗机构信息，并迅速安排就医。</p>
        <h5 class="customer-example">案例1</h5>
        <div class="customer-flow">
          <div class="flow-head">
            <p>头痛3天，症状无改善希望就医。</p>
            <p>就诊需求：今日尽早，能中文交流的医疗机构。</p>
          </div>
          <span class="flow-mid"></span>
          <div class="flow-foot">
            <p>根据患者需求及地理定位筛选出推荐备选医院，并实际致电医院确认后完成预约。</p>
            <p>为患者说明预约结果及就诊理赔所需材料。 </p>
          </div>
        </div>
        <h5 class="customer-example">案例2</h5>
        <div class="customer-flow">
          <div class="flow-head">
            <p>意外摔倒后磕到嘴部，造成门牙断裂。希望去医院进行紧急处理，但身在国外小城市，深夜又英文交流困难不知如何就医···</p>
          </div>
          <span class="flow-mid"></span>
          <div class="flow-foot">
            <p>首先为患者介绍能够能够急诊就医的医院。如有必要，当地时间一早为患者安排口腔科专科就诊。就诊过程中由EAJ客服人员提供电话翻译服务。</p>
          </div>
        </div>
      </div>
      <h4 class="rescue-title"
          style="margin-bottom:0;">医疗救援图解 </h4>
      <div class="experience-part"
           style="margin-bottom:0;">
        <img class="rescue-img"
             style="width:905px;height:693px;margin:24px auto 99px auto;"
             :src="customer12"
             alt="">
      </div>
      <h4 class="rescue-title"
          id="one">重症救援案例</h4>
      <div class="experience-part">
        <p class="more-case">重症救援案例：海外常驻员工转运案例</p>
        <p class="experience-para"
           style="margin-bottom:37px!important;">从接到伤病报案开始实时监控治疗情况，并根据顾问医生的见解内容作出归国转运的判断。</p>
        <table class="other-service">
          <tbody>
            <tr>
              <td>患者年龄/性别</td>
              <td>B某（52岁）/男性</td>
            </tr>
            <tr>
              <td>事故地点-目的地</td>
              <td>墨西哥-中国</td>
            </tr>
            <tr>
              <td>诊断名 </td>
              <td>剥离性主动脉瘤</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="experience-part customer-block">
        <h5 class="case-title">案件经过</h5>
        <div class="text">
          <p>B某作为某公司在M国的当地项目负责人，常驻墨西哥。</p>
          <p>因半夜突发性的后背疼痛和左下肢麻痹联系EAJ安排就医。</p>
          <p>在急诊初步诊断为腹痛待查，疑似急性肠胃炎，因患者疼痛严重住院留观。</p>
          <p>对症治疗后患者症状无改善，遂进行腹部CT检查，确诊为剥离性主动脉瘤。</p>
          <p>剥离范围较大，但动脉瘤并没有破裂，无需紧急手术，最终选择了保守治疗稳定病情后转运回国。</p>
          <p>EAJ安排患者病情稳定后在医护人员陪同下回国进一步治疗。</p>
          <p>现在患者已经康复回归了职场。</p>
        </div>
        <h5 class="case-title">救援内容</h5>
        <div class="text">
          <p>
            <span>①</span>
            <span> 救援客服中心接到患者报案，紧急安排患者急诊就医，并垫付治疗费用。</span>
          </p>
          <p>
            <span>②</span>
            <span> 救援客服中心随时监控患者治疗情况，取得医疗信息并将译成中文的信息共享给企业负责人及患者亲属。</span>
          </p>
          <p>
            <span>③</span>
            <span> 由威马捷顾问医生（航空医疗经验丰富的医生）给出建议：尽量卧床静养，控制血压，如果剥离范围没有继续扩大，考虑到患者所在地与中国的距离和飞行时间，建议现地稳定3周后再考虑医疗转运可大大降低转运风险。</span>
          </p>
          <p>
            <span>④</span>
            <span> 安排当地翻译人员在每天上午医生查房时前往医院陪同翻译。</span>
          </p>
          <p>
            <span>⑤</span>
            <span> 应患者亲属要求安排其前往现探视所需的机票，现地酒店及接机用车。</span>
          </p>
          <p>
            <span>⑥</span>
            <span> 根据患者身体情况作出医疗转运计划，安排转运医疗团队，转运航班及地面转运车辆等具体事宜，并安排了医疗交接及陪同翻译，预约了国内接收医院。</span>
          </p>
          <p>
            <span>⑦</span>
            <span> 患者在当地住院21天后，在1名医生和1名护士的陪同下，医疗转运回国。</span>
          </p>
          <p>
            <span>⑧</span>
            <span> 全程费用由EAJ进行事先垫付，并代理保险申请。</span>
          </p>
        </div>
      </div>
      <div class="experience-part">
        <p class="more-case">海外常驻员工猝死后遗体转运案例</p>
        <p class="experience-para"
           style="margin-bottom:37px!important;">从接到死亡报案起开始安排当地遗体处置事宜，可根据委托人要求安排现地火葬或遗体转运回国。</p>
        <table class="other-service">
          <tbody>
            <tr>
              <td>患者年龄/性别</td>
              <td>A某（47岁）/男性</td>
            </tr>
            <tr>
              <td>事故地点-目的地</td>
              <td>老挝（Bolikhamsai）- 日本</td>
            </tr>
            <tr>
              <td>诊断名 </td>
              <td>猝死（疑似脑出血）</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="experience-part customer-block">
        <h5 class="case-title">案件经过</h5>
        <div class="text">
          <p> A某作为大型零件制作公司的技术人员独自一人在海外的S市常驻已经2年了。</p>
          <p>某周一的早上，从不迟到的A某无故缺勤，没有任何联系也不接公司的电话。</p>
          <p>同事出于担心前往A某的公寓查看，通过管理员的备用钥匙开门后发现A某穿着睡衣倒在客厅。</p>
          <p>A某同事在第一时间叫了救护车并联系了EAJ。救护车到达现场后确认了A某已经没有生命体征，并联系了警方接手。</p>
          <p>警方进行了现场侦查排除他杀后将遗体送往当地指定医院的安置所。警方验尸结果，死因诊断为疑似脑出血。</p>
          <p>会员企业联系EAJ希望协助办理相关手续尽快将死者遗体转运回国。</p>
          <p>EAJ紧急派遣泰国分中心员工赶往当地协调处理相关事宜，于会员死后第三天实施了遗体转运将遗体送到了亲属指定的殡仪馆。</p>
        </div>
        <h5 class="case-title">死亡救援案例</h5>
        <div class="text">
          <p>
            <span>①</span>
            <span>EAJ在会员死亡当天接到企业委托后，立即确认当地遗体转运手续流程及费用预算。<br>正常手续流程需要7个工作日进行转运，应企业尽快完成转运要求，EAJ派遣工作人员赶赴当地协助办理相关手续，并就相关费用进行垫付/挂账。</span>
          </p>
          <p>
            <span>②</span>
            <span>救援客服人员第一时间与当地大使馆联系报案并说明之后的遗体的处理安排。</span>
          </p>
          <p>
            <span>③</span>
            <span>EAJ的现地救援人员在会员死后第二天上午与死者亲属及国内企业负责人一起到达当地。陪同死者亲属及企业面见遗体，办理警方手续并取得死亡证明书。</span>
          </p>
          <p>
            <span>④</span>
            <span>EAJ现地救援人员陪同死者亲属前往当地大使馆办理死亡证明书照会手续。</span>
          </p>
          <p>
            <span>⑤</span>
            <span>同时EAJ通过合作的现地代理办理遗体国际转运材料，并且联系航空公司预留的2天后的转运舱位。</span>
          </p>
          <p>
            <span>⑥</span>
            <span>因当地殡仪馆不具备转运防腐能力，EAJ联系泰国殡仪馆防腐专业人员来到当地处理遗体。</span>
          </p>
          <p>
            <span>⑦</span>
            <span>死者亲属希望遗体转运回国后通过司法解剖明确死因。EAJ再次确认转运防腐处理不会影响解剖及影响检查结果。并通过调查提供了能够司法解剖机构的信息。</span>
          </p>
          <p>
            <span>⑧</span>
            <span>EAJ联系大使馆领事，见证封棺并开具遗体证明书。</span>
          </p>
          <p>
            <span>⑨</span>
            <span>在殡仪馆检疫封棺后运往机场过海关，经泰国曼谷转运回日本关西机场。EAJ安排亲属乘坐同一航班回国。</span>
          </p>
          <p>
            <span>⑩</span>
            <span>EAJ安排目的地殡仪馆前往机场接收遗体并送往死者亲属指定安置所并垫付国内地面转运相关费用。</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import customer01 from '@/assets/images/rescue/customer01.jpg'
import customer02 from '@/assets/images/rescue/customer02.png'
import customer05 from '@/assets/images/rescue/customer05.jpg'
import customer06 from '@/assets/images/rescue/customer06.jpg'
import customer10 from '@/assets/images/rescue/customer10.jpg'
import customer11 from '@/assets/images/rescue/customer11.png'
import customer12 from '@/assets/images/rescue/customer12.png'
export default {
  data () {
    return {
      customer01,
      customer02,
      customer05,
      customer06,
      customer10,
      customer11,
      customer12
    }
  },
  created () {
    document.title = '呼叫中心-医疗转运-回国-医疗报告-旅行援助-全球救援-威马捷'
    this.$nextTick(() => {
      this.getlocal()
    })
  },
  mounted () {
    // localStorage.setItem('RescueScrollTop', scrollTop)
    // alert(localStorage.getItem('RescueScrollTop'))
  },
  destroyed () {
    localStorage.setItem('linkId', '')
  },
  methods: {
    getlocal () {
      let id = localStorage.getItem('linkId')
      let elm = document.getElementById(id)
      if (id) {
        elm.scrollIntoView(true)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.global-rescue {
  margin-bottom: 100px;
}
.other-service {
  width: 925px;
  margin: 0 auto;
  tr {
    th {
      background: #e9edf4;
      color: #1d1812;
      font-size: 16px;
      line-height: 60px;
      // border: 2px solid #fff;
    }
    td {
      box-sizing: border-box;
      border: none !important;

      &:first-child {
        width: 268px;
        font-size: 16px;
        color: #242424;
        text-align: left;
        padding-left: 14px;
        border-right: 1px solid #c2ccde !important;
      }
      &:last-child {
        font-size: 16px;
        color: #242424;
        line-height: 36px;
        padding: 16px;
      }
    }
  }
  tbody {
    tr {
      &:nth-child(odd) {
        background: #e9edf4;
      }
      &:nth-child(even) {
        background: #d0d8e7;
      }
      td {
        border: 2px solid #fff;
      }
    }
  }
}
.experience-part {
  // padding: 36px 32px;
  border: none;
  padding: 0;
}
.experience-para {
  margin-bottom: 42px !important;
}
.rescue-box-item {
  width: 454px;
}
.rescue-box-item:last-child {
  margin-left: 18px;
}
.customer-special {
  width: 804px;
  height: 124px;
  background-color: #ae1e10;
  border-radius: 10px;
  margin: 0 auto;
  padding: 22px 215px;
  box-sizing: border-box;
  color: #fff;
  .left {
    float: left;
    font-size: 16px;
    color: #fff;
    width: 130px;
    line-height: 27px;
  }
  .mid {
    float: left;
    margin: 0 41px;
    font-size: 30px;
    color: #fff;
    width: 20px;
    line-height: 82px;
  }
  .right {
    float: left;
    font-size: 26px;
    color: #fff;
    width: 130px;
    line-height: 42px;
  }
}
.structure {
  width: 804px;
  display: table;
  margin: auto;
  .top {
    height: 130px;
    .left,
    .right {
      width: 385px;
      height: 100px;
      float: left;
      background-color: #e9ebf4;
      font-size: 16px;
      color: #333130;
      line-height: 100px;
      margin-top: 30px;
      border-radius: 10px;
      text-align: center;
    }
    .mid {
      width: 20px;
      float: left;
      height: 85px;
      margin: 0 5px;
      span {
        display: block;
        width: 3px;
        height: 83px;
        margin: 0 auto;
        background-color: #e9ebf4;
      }
      .vertical {
      }
      .transverse {
        width: 20px;
        height: 3px;
      }
    }
  }
  .bottom {
    .item {
      float: left;
      width: 192px;
      height: 149px;
      background: #e9ebf4;
      border-radius: 10px;
      margin-right: 11px;
      padding: 24px 14px;
      box-sizing: border-box;
      font-size: 16px;
      line-height: 32px;
      color: #333130;
    }
    .item:last-child {
      margin-right: 0;
    }
  }
  .middle {
    height: 31px;
    width: 618px;
    margin: auto;
    .item {
      width: 214px;
      height: 31px;
      float: left;
      .top {
        display: block;
        width: 3px;
        height: 21px;
        background-color: #e9ebf4;
        margin-left: 50%;
      }
      .bot {
        display: block;
        width: 214px;
        height: 9px;
        border: 3px solid #e9ebf4;
        border-bottom: none;
      }
    }
    .item:last-child {
      margin-left: 190px;
    }
  }
}
.customer-title {
  font-size: 24px;
  color: #2e2e2e;
  line-height: 50px;
  border-bottom: 18px solid #ffd9db;
  background: url('../assets/images/rescue/customer04.png') no-repeat;
  padding-left: 45px;
  margin-bottom: 30px;
  margin-top: 50px;
}
.title01 {
  // background-position: 0 8px;
}
.title02 {
  background-position: 0 -76px;
}
.customer-list {
  // margin-bottom: 0;
  // padding-left: 0;
  li {
    // list-style-type: disc;
    // list-style-position: inside;
    font-size: 16px;
    color: #333130;
    line-height: 32px;
    display: table;
    width: 100%;
    span {
      display: block;
      float: left;
    }
    .icon {
      width: 21px;
      text-align: left;
      font-size: 30px;
    }
    .text {
      width: 405px;
      font-size: 16px;
      margin-left: 2px;
    }
  }
}
.customer-table {
  width: 100%;
  tr {
    td {
      font-size: 20px;
      color: #2e2e2e;
      line-height: 24px;
      padding: 28px 30px;
    }
    &:nth-child(odd) {
      background: #d0d8e7;
    }
    &:nth-child(even) {
      background: #e9edf4;
    }
  }
}
.customer-example {
  font-size: 20px;
  color: #2e2e2e;
  margin: 40px auto 29px auto;
}
.customer-flow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 920px;
  margin: 0 auto;
  p {
    font-size: 16px;
    color: #333130;
    line-height: 32px;
  }
  .flow-head,
  .flow-foot {
    width: 380px;
    height: 120px;
    padding-right: 46px;
    border: 2px solid #d8dbeb;
    border-top: none;
    border-right: none;
    padding: 10px;
    box-sizing: border-box;
  }
  .flow-mid {
    display: block;
    width: 10px;
    height: 30px;
    border-style: solid;
    border-color: transparent transparent transparent #e9ebf4;
    border-width: 18px;
    margin-left: 18px;
  }
}
.customer-block {
  ul li,
  p {
    font-size: 24px;
    color: #333130;
    line-height: 30px;
  }
}
.customer-part {
  margin-bottom: 36px;
}
.more-case {
  margin: 30px 0 12px;
}
.case-title {
  position: relative;
  font-size: 20px;
  color: #333130;
  line-height: 30px;
  padding-left: 25px;
  margin-top: 35px;
  margin-bottom: 18px;
  &::before {
    position: absolute;
    left: 0;
    top: 8px;
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    background: #343230;
  }
}
.text {
  margin-left: 24px;
  p {
    font-size: 16px;
    line-height: 32px;
    color: #343230;
    display: table;
    width: 100%;
    span {
      display: block;
      float: left;
    }
    span:first-child {
      width: 20px;
      margin-right: 4px;
    }
    span:last-child {
      width: 864px;
    }
  }
}
.case-img {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 70px;
}
</style>